import { useEffect, useState } from 'react';
import './OptionsDialog.css';

const normalizeColor = (c) => {
  if (!c) return '';
  let x = String(c).trim();
  if (!x.startsWith('#')) x = '#' + x;
  return /^#[0-9a-fA-F]{6}$/.test(x) ? x.toUpperCase() : '';
};

// value: Array<string | {value,color}>
export default function OptionsDialog({ open = false, value = [], onSave, onClose }) {
  // Eingehende Werte normalisieren
  const parseIn = (arr) => {
    const out = [];
    for (const it of (Array.isArray(arr) ? arr : [])) {
      if (typeof it === 'object' && it !== null) {
        const v = String(it.value ?? '').trim();
        out.push({ value: v, color: normalizeColor(it.color ?? '') || '#FFFFFF' });
      } else {
        const raw = String(it ?? '').trim();
        if (!raw) { out.push({ value: '', color: '#FFFFFF' }); continue; }
        const [val, maybeHex] = raw.split('|');
        out.push({ value: (val || '').trim(), color: normalizeColor(maybeHex ?? '') || '#FFFFFF' });
      }
    }
    return out.length ? out : [{ value: '', color: '#FFFFFF' }];
  };

  const [rows, setRows] = useState(() => parseIn(value));

  useEffect(() => {
    if (open) setRows(parseIn(value));
  }, [open, value]);

  const addRow = () => setRows(prev => [...prev, { value: '', color: '#FFFFFF' }]);
  const delRow = (i) => setRows(prev => prev.filter((_, idx) => idx !== i));
  const updateRow = (i, patch) => setRows(prev => prev.map((r, idx) => idx === i ? { ...r, ...patch } : r));

  const save = () => {
    const valid = rows
      .map(r => ({ value: String(r.value || '').trim(), color: normalizeColor(r.color) || '#FFFFFF' }))
      .filter(r => r.value.length > 0);
    onSave?.(valid);
  };

  if (!open) return null;

  return (
    <div className="settings-backdrop" onClick={onClose}>
      <div className="settings-dialog small" onClick={(e) => e.stopPropagation()}>
        <div className="settings-header">
          <h3>Optionen bearbeiten</h3>
        </div>

        <div className="opt-editor">
          <div className="opt-head">
            <span className="opt-col opt-val">Wert</span>
            <span className="opt-col opt-colr">Farbe</span>
            <span className="opt-col opt-act">Aktionen</span>
          </div>

          {rows.map((r, i) => (
            <div className="opt-row" key={i}>
              <input
                className="opt-val"
                placeholder="z.B. BBK"
                value={r.value}
                onChange={e => updateRow(i, { value: e.target.value })}
              />
              <div className="opt-color-wrap">
                <input
                  className="opt-colr"
                  type="text"
                  placeholder="#RRGGBB"
                  value={r.color}
                  onChange={e => updateRow(i, { color: e.target.value })}
                />
                <input
                  className="opt-colr-picker"
                  type="color"
                  value={r.color || '#FFFFFF'}
                  onChange={e => updateRow(i, { color: e.target.value })}
                  title="Farbe wählen"
                />
              </div>
              <div className="opt-act">
                <button type="button" onClick={() => delRow(i)} title="Option löschen">❌</button>
              </div>
            </div>
          ))}

          <button className="opt-add" type="button" onClick={addRow}>+ Option hinzufügen</button>

          <div className="settings-footer">
            <button type="button" onClick={onClose}>Abbrechen</button>
            <button className="primary" type="button" onClick={save}>Speichern</button>
          </div>
        </div>
      </div>
    </div>
  );
}
